var map = {
	"./x10.png": 29785,
	"./x100.png": 48349,
	"./x2.png": 87094,
	"./x20.png": 836,
	"./x25.png": 80841,
	"./x3.png": 40895,
	"./x4.png": 12864,
	"./x5.png": 37065,
	"./x50.png": 12525,
	"./x6.png": 72530,
	"./x7.png": 94075,
	"./x8.png": 90060,
	"./x9.png": 1685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26901;